import React from "react";
import { Flex, Box } from "@chakra-ui/react";
import { type Integration } from "lib/sanity";
import { Video } from "ui/video";
import { SuccessIcon } from "ui/icons";
import ReactMarkdown from "react-markdown";
import { Link } from "ui/link";
import { remCalc } from "theme/utils";
import { Section } from "./section";

type IntegrationsExplainerVideoProps = {
  features?: Integration["features"];
};

function IntegrationsExplainerVideo({ features }: IntegrationsExplainerVideoProps) {
  return (
    <Section my="0" py={features ? { base: "huge", md: "huger" } : { base: "biggest", md: "huge" }}>
      <Flex direction={{ base: "column", lg: "row" }} width="100%" justify="flex-start" align="center" gap="bigger">
        {features && features.length > 0 && (
          <Flex
            direction="column"
            gap={{ base: "smaller", md: "small" }}
            align="flex-start"
            maxW={740}
            mx="auto"
            flex={1}
          >
            {features?.map((feature: string) => (
              <Flex key={feature} position="relative" align="start" gap={4} textStyle="caption1">
                <Box position="relative" mt={remCalc(-2)}>
                  <SuccessIcon boxSize="icon.md" color="new.green.500" />
                </Box>

                <ReactMarkdown
                  components={{
                    a: ({ node, href, ...props }) => <Link href={href} variant="inlineDark" {...props} />,
                  }}
                >
                  {feature}
                </ReactMarkdown>
              </Flex>
            ))}
          </Flex>
        )}

        <Box maxW="4xl" flex={1} mx="auto">
          <Video
            title="Learn how you can activate your data with Hightouch."
            description="Watch this quick video and learn how to activate your data with Hightouch in less than 5 minutes."
            width="100%"
            source="https://cdn.sanity.io/files/pwmfmi47/production/bd782e3fa717b902ec4820ee72c45049f355910b.mp4"
            poster="/assets/home/video-poster.webp"
            uploadDate="2022-09-14T08:00:00+08:00"
          />
        </Box>
      </Flex>
    </Section>
  );
}

export default IntegrationsExplainerVideo;
